import { render, staticRenderFns } from "./NewPW.vue?vue&type=template&id=6adca95c&scoped=true&"
import script from "./NewPW.vue?vue&type=script&lang=js&"
export * from "./NewPW.vue?vue&type=script&lang=js&"
import style0 from "./NewPW.vue?vue&type=style&index=0&id=6adca95c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adca95c",
  null
  
)

export default component.exports